import React, { FC } from 'react';
import { TWCMoonIcon, TWCText } from '@components';

import { dailyDaypartForecastTestIDs } from '@constants';
import { MoonIconCode } from '@types';

import { styles } from './styles';

type DaypartNightProps = {
  daypartName: string;
  error?: unknown;
  moonPhase: string;
  moonPhaseCode: MoonIconCode;
  t: (val: string) => string;
};

export const DaypartNight: FC<DaypartNightProps> = ({ daypartName, error, t, moonPhase, moonPhaseCode }) => {
  const testIDs = dailyDaypartForecastTestIDs;

  return (
    <>
      <TWCText testID={testIDs.dayName} variant={'regularText'}>
        {error ? '—' : daypartName}
      </TWCText>
      <TWCText style={styles.moonPhaseLabel} testID={testIDs.moonPhaseLabel} variant={'regularText24Transparent'}>
        {t('moonPhaseLabel')}
      </TWCText>
      <TWCMoonIcon code={moonPhaseCode} height={30} width={30} />
      <TWCText style={styles.moonPhaseValue} testID={testIDs.moonPhaseValue} variant={'regularText30'}>
        {error ? '—' : moonPhase}
      </TWCText>
    </>
  );
};
